import { cardAspectRatio, layout } from '../../theme/tokens';

export interface ImageSizing {
  width?: number;
  aspectRatio?: string;
}

export interface ResponsiveImageSizing {
  mobile: ImageSizing;
  desktop: ImageSizing;
}

export type ImageTransform = (src: string, sizing?: ImageSizing) => string;

export type CardSize = 'small' | 'large';

export const defaultCardAspectRatio = (size: CardSize) =>
  size === 'small' ? cardAspectRatio.compact : cardAspectRatio.listing;

const WIDEST_RENDERED_CARD_WIDTH: Record<CardSize, number> = { large: 800, small: 400 };

export const DESKTOP_IMAGE_MEDIA = `(min-width: ${layout.desktopBreakpoint})`;

export const THUMBNAIL_IMAGE_SIZING: ImageSizing = { width: 240, aspectRatio: '1:1' };

const isRenderableRatio = (ratio: string): boolean => {
  const [width, height] = ratio.split(/[:/]/).map(Number);
  return width > 0 && height > 0;
};

const toImgixRatio = (ratio: string, fallback: string): string =>
  (isRenderableRatio(ratio) ? ratio : fallback).replace(/\s*\/\s*/, ':');

export const resolveCardImageSizing = (
  size: CardSize = 'large',
  aspectRatio?: string,
  mobileAspectRatio?: string
): ResponsiveImageSizing => {
  const { desktop, mobile } = defaultCardAspectRatio(size);
  const width = WIDEST_RENDERED_CARD_WIDTH[size];

  return {
    desktop: { width, aspectRatio: toImgixRatio(aspectRatio ?? desktop, desktop) },
    mobile: {
      width,
      aspectRatio: toImgixRatio(mobileAspectRatio ?? aspectRatio ?? mobile, mobile),
    },
  };
};

export const CARD_IMAGE_SIZING: ImageSizing = resolveCardImageSizing('large').desktop;
